/**
 * Custom JS to go here
 */

const toggleButtons = [...document.querySelectorAll('.toggle-button')];

const toggleButtonToggle = (event) => {
  const currentButton = event.currentTarget;
  const currentItem = currentButton.closest('.toggle-button');

  if (currentButton.getAttribute("aria-expanded") === "false") {
    currentButton.setAttribute("aria-expanded", "true");
    currentItem.classList.add("active");
  } else {
    currentButton.setAttribute("aria-expanded", "false");
    currentItem.classList.remove("active");
  }
};

toggleButtons.forEach((toggleButton) => {
  const toggleButtonButton = toggleButton.querySelector('.toggle-button__button');

  toggleButtonButton.addEventListener('click', toggleButtonToggle);
});